/**
 * Bridge alma-embeds TrafficManagement events into Ampparit GTM dataLayer.
 * Embeds call window.sendCustomGA4Event when window.loadGAFromSite is true.
 */

import { withClearedGa4Variables } from './ga4DataLayer'

export function sendCustomGA4Event({ eventName, eventDimensions = {} } = {}) {
  if (typeof window === 'undefined') {
    return
  }

  window.dataLayer = window.dataLayer || []

  const variant = window.__AMP_AB_TEST_VARIANT
  const placement = window.__AMP_TRAFFIC_STEERING_PLACEMENT
  const target = eventDimensions.eventTarget
  const uiElement = [placement, target].filter(Boolean).join('_') || undefined

  window.dataLayer.push(withClearedGa4Variables({
    event: 'sendGAEvent',
    'dlv - eventName': eventName,
    'dlv - ab_test_variant': variant,
    'dlv - event_value': eventDimensions.eventAction,
    'dlv - ui_element': uiElement,
    eventAction: eventDimensions.eventAction,
    eventCategory: eventDimensions.eventCategory,
    eventTarget: target,
    eventData1: eventDimensions.eventData1,
    eventData2: eventDimensions.eventData2,
    eventData3: eventDimensions.eventData3,
    eventData4: eventDimensions.eventData4,
    userType: eventDimensions.userType,
    targetPageId: eventDimensions.targetPageId,
  }))
}

export function setTrafficSteeringAnalyticsContext({ variant, placement } = {}) {
  if (typeof window === 'undefined') {
    return
  }
  if (variant) {
    window.__AMP_AB_TEST_VARIANT = variant
  }
  if (placement) {
    window.__AMP_TRAFFIC_STEERING_PLACEMENT = placement
  }
}

export function installTrafficSteeringAnalytics() {
  if (typeof window === 'undefined') {
    return
  }
  window.loadGAFromSite = true
  window.sendCustomGA4Event = sendCustomGA4Event
}
